import { render } from "./CartViewProduct.vue?vue&type=template&id=5b027491"
import script from "./CartViewProduct.vue?vue&type=script&lang=js"
export * from "./CartViewProduct.vue?vue&type=script&lang=js"

import exportComponent from "/Users/davidebertuzzi/WebstormProjects/procremonafrontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__